<div class="dialog-wrap">
  <div class="image-wrap">
    <img *ngIf="file && isImageFile(data.file.fileName)" [src]="file" alt="preview">
  </div>
  <div class="pdf-wrap" *ngIf="file && isPdfFile(data.file.fileName)">
    <pdf-viewer [src]="file"
    ></pdf-viewer>
  </div>
</div>
